import { useAdditionalQuestionsForm } from 'components/OrderForm/BillingShipping/hooks/useAdditionalQuestionsForm';
import { Controller, FormProvider } from 'react-hook-form';
import React, { Fragment } from 'react';
import {
  ClientFedexAccountInput,
  ImageAnalysisAndPathologyConsultationTimeInput,
  ShipBackUnstainedSlidesInput,
} from 'components/OrderForm/components/AdditionalQuestionsFormInput';
import {
  Button,
  Grid,
  Paper,
  Tab,
  Tabs,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import { ClientFedexRequired } from 'components/OrderForm/BillingShipping/BillingShippingComponents';
import { SubmittingIcon } from 'components/icons/LoadingIcon';
import Box from '@mui/material/Box';
import Portal from '@mui/material/Portal';
import { TeamAddressForm } from 'components/Shared/TeamAddress/TeamAddressFormV1';
import { TabPanel } from 'components/Shared/TabPanel';
import { AddressSelect } from 'components/OrderForm/BillingShipping/ShippingTabs/AddressSelect';
import { useBillingShippingStyles } from 'components/OrderForm/BillingShipping/styles';
import { serializedTrueFalseOptionsToSelectInput } from 'components/OrderForm/constants';

export const AdditionalQuestionsForm = () => {
  const { classes } = useBillingShippingStyles();
  const {
    methods,
    onSubmit,
    orderRequestedIAOrPC,
    unstainedSlidesRequested,
    handleShippingTabChange,
    shippingTabSelected,
    shippingBackAddressSelected,
    setShippingBackAddressSelected,
    shippingAddresses,
    isFedexVisible,
    setValue,
    client_fedex_account,
    handleAddTeamAddressSuccess,
    shippingAddressSelected,
    teamUUID,
    submitting,
    ship_back_unstained_slides,
    portalRef,
  } = useAdditionalQuestionsForm();

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          {/* If requested image analysis or path consult then ask followup how many days */}
          {orderRequestedIAOrPC && (
            <ImageAnalysisAndPathologyConsultationTimeInput name="turnaround_image_analysis_pathology_consultation_days" />
          )}
          <Paper className={classes.confirmPaper}>
            <Grid container direction="row" wrap="nowrap" alignItems="baseline">
              <span>
                HistoWiz stores all blocks in our Digital Block Management
                System, which provides you with live digital access to a
                comprehensive catalog of your samples. HistoWiz offers
                complimentary storage for a period of one (1) calendar month
                upon the completion of processing. After this period, storage
                fees will apply at a rate of $0.99 per block per month. You can
                request blocks to be shipped back on the Orders Page{' '}
                <i>anytime after the order is completed</i>.
              </span>
            </Grid>
          </Paper>
          <Paper className={classes.confirmPaper}>
            <Grid container direction="row" wrap="nowrap" alignItems="baseline">
              <Grid item>
                <FormControlLabel
                  control={
                    <Controller
                      name="ship_back_samples"
                      control={methods.control}
                      render={({ field: props }) => (
                        <Checkbox
                          {...props}
                          checked={props.value.value}
                          onChange={(e) =>
                            props.onChange(
                              serializedTrueFalseOptionsToSelectInput[
                                e.target.checked
                              ],
                            )
                          }
                        />
                      )}
                    />
                  }
                  label=""
                />
              </Grid>
              <Grid item>
                <span>
                  I request the return of my blocks following the completion of
                  this order as I do not require immediate additional
                  processing. I acknowledge that by selecting this option, and I
                  will forgo the complimentary storage period and will incur a
                  shipping fee of $50.
                </span>
              </Grid>
            </Grid>
          </Paper>
          {unstainedSlidesRequested && (
            <>
              <ShipBackUnstainedSlidesInput name="ship_back_unstained_slides" />
              {ship_back_unstained_slides.value && (
                <Grid container direction="row" justifyContent="space-between">
                  {shippingAddressSelected ? (
                    <Grid item xs={7} className={classes.addressContainer}>
                      {/* <ShippingAddressDisplay address={shippingAddressSelected} /> */}
                      <Paper className={classes.paper}>
                        <Tabs
                          value={shippingTabSelected}
                          indicatorColor="secondary"
                          textColor="secondary"
                          onChange={handleShippingTabChange}
                        >
                          <Tab label="Add Address" />
                          <Tab label="Existing Ship Back Address" />
                        </Tabs>
                        <Box ref={portalRef} index={0} />
                        <TabPanel value={shippingTabSelected} index={1}>
                          <AddressSelect
                            value={shippingBackAddressSelected}
                            onChange={setShippingBackAddressSelected}
                            shippingAddresses={shippingAddresses}
                          />
                        </TabPanel>
                      </Paper>
                    </Grid>
                  ) : (
                    <p>Select shipping address first</p>
                  )}
                </Grid>
              )}
            </>
          )}
          {/* Conditional Logic to only show up if either ship back slides or ship back samples is yes */}
          {isFedexVisible && (
            <>
              <ClientFedexAccountInput name="client_fedex_account" />
              {!client_fedex_account && (
                <ClientFedexRequired
                  name="client_fedex_account"
                  setValue={setValue}
                />
              )}
            </>
          )}
          <Grid container direction="row-reverse">
            <div className={classes.saveButton}>
              <Button type="submit" variant="contained" color="primary">
                <SubmittingIcon submitting={submitting} />
                Save & Continue
              </Button>
            </div>
          </Grid>
        </form>
      </FormProvider>
      {!shippingTabSelected && (
        <Portal container={portalRef.current}>
          <TeamAddressForm
            teamUUID={teamUUID}
            onAfterSuccessSubmit={handleAddTeamAddressSuccess}
          />
        </Portal>
      )}
    </>
  );
};
